import { BrowserModule } from '@angular/platform-browser';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { RippleModule } from 'primeng/ripple';
import { AvatarModule } from 'primeng/avatar';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { BreadcrumbModule } from 'primeng/breadcrumb';

import Aura from '@primeng/themes/aura';
// @ts-ignore
import { definePreset } from '@primeng/themes';
import { TranslateModule } from '@ngx-translate/core';
import { CommonSharedModule } from '../common-shared/common-shared.module';
import { navigationDeclarations } from './navigation';
import { LoginComponent } from './routes/login/login.component';
import { STORAGE_DB_CONFIG } from '../common-shared/storage-db/types';
import { apiEndpoints, storageDbConfig } from './config';
import { API_CONFIG, API_ENDPOINTS } from '../common-shared/api';
import { environment } from '../environments/environment';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
} from '@azure/msal-angular';

import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

import { LoginMsalComponent } from './routes/login-msal/login-msal.component';
import { ServiceWorkerModule } from '@angular/service-worker';

/*import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';*/
/*import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';

import {
  LANGUAGE_TRANSLATIONS,
  TRANSLATE_CONFIG
} from './common-shared/translate/types';

import {
  STORAGE_DB_CONFIG
} from './common-shared/storage-db/types';
import {
  translateConfig,
  languageTranslations,
  enumsConfig,
  smartFormConfig,
  companyConfig,
  emailsAccountsConfig,
  storageDbConfig, htmlDocumentsConfig
} from './config';

import {API_CONFIG, API_ENDPOINTS} from './common-shared/api/types';
import {SMARTFORM_DEFINITIONS} from './common-shared/smart-form/types';
import {ENUMS_CONFIG} from './common-shared/enums/types';
import {VALIDATORS_CONFIG} from './common-shared/validators/types';
import {apiEndpoints} from "./config/api/api-endpoints";
import {validatorsConfig} from "./config/validators/validators.config";
import {CommonSharedModule} from "./common-shared/common-shared.module";
import {EMAILS_ACCOUNTS_CONFIG} from "./common-shared/admin/types/providers-config";
import {APP_CONFIG} from "./common-shared/app/types";
import {COMPANY_CONFIG} from "./common-shared/company/types";
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  getBrowserLocale, getCookie, HTML_DOCUMENTS_CONFIG,
} from "./common-shared";
import {GTM_CONFIG} from "./common-shared/gtm";

function getLanguageIfAllowed(language: string, allowedLanguages: string[]): string {
  return language && allowedLanguages.indexOf(language) >= 0 ? language : '';
}
*/

const Noir = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{surface.50}',
      100: '{surface.100}',
      200: '{surface.200}',
      300: '{surface.300}',
      400: '{surface.400}',
      500: '{surface.500}',
      600: '{surface.600}',
      700: '{surface.700}',
      800: '{surface.800}',
      900: '{surface.900}',
      950: '{surface.950}',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.950}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.800}',
          activeColor: '{primary.700}',
        },
        highlight: {
          background: '{primary.950}',
          focusBackground: '{primary.700}',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
      dark: {
        primary: {
          color: '{primary.50}',
          contrastColor: '{primary.950}',
          hoverColor: '{primary.200}',
          activeColor: '{primary.300}',
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.300}',
          color: '{primary.950}',
          focusColor: '{primary.950}',
        },
      },
    },
  },
});

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalClientId,
      authority: environment.msalAuthority,
      redirectUri: environment.msalRedirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      temporaryCacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false,
      secureCookies: false,
    },
  });
}
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginMsalComponent,
    /*...navigationDeclarations,*/
  ],
  imports: [
    BrowserModule,
    MsalModule,
    AppRoutingModule,
    CommonSharedModule.forRoot(),
    /*CommonSharedModule.forRoot(),*/
    /*ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.useServiceWorkers})*/
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.useServiceWorkers,
    }),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
    }),
  ],
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Noir,
        options: {
          prefix: 'p',
          darkModeSelector: '.p-dark',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
    /*{provide: LANGUAGE_TRANSLATIONS, useValue: languageTranslations},*/
    { provide: STORAGE_DB_CONFIG, useValue: storageDbConfig },
    { provide: API_ENDPOINTS, useValue: apiEndpoints },
    {
      provide: API_CONFIG,
      useValue: {
        apiUrl: environment.apiUrl,
        apiCode: environment.apiCode,
      },
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    /*{provide: VALIDATORS_CONFIG, useValue: validatorsConfig},
    {provide: SMARTFORM_DEFINITIONS, useValue: smartFormConfig},*/
    /*{
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [MSAL_INSTANCE],
      multi: true,
    },*/
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
